import ChalkySticks from '@chalkysticks/sdk';
import Store from '@/Store';
import { Capacitor } from '@capacitor/core';
import { Keyboard, KeyboardInfo } from '@capacitor/keyboard';

/**
 * Whether keyboard manager has been initialized
 *
 * @type boolean
 */
let hasInitialized: boolean = false;

/**
 * Initialize keyboard detection.
 *
 * @return Promise<void>
 */
export async function initialize(): Promise<void> {
	if (hasInitialized) {
		return;
	}

	if (!Capacitor.isNativePlatform()) {
		hasInitialized = true;
		return;
	}

	/**
	 * @param KeyboardInfo info
	 * @return void
	 */
	const keyboardShowing = (info: Partial<KeyboardInfo> = {}): void => {
		Store.commit('setShowingKeyboard', true);
		ChalkySticks.Core.Event.Bus.dispatch('keyboard:show', info);
	};

	/**
	 * @return void
	 */
	const keyboardHiding = (): void => {
		Store.commit('setShowingKeyboard', false);
		ChalkySticks.Core.Event.Bus.dispatch('keyboard:hide');
	};

	// Android uses resize events
	if (ChalkySticks.Utility.Device.isAndroid()) {
		window.addEventListener('resize', (e: Event) => {
			const ratio = window.innerHeight / window.innerWidth;
			ratio < 1.5 ? keyboardShowing() : keyboardHiding();
		});
	} else {
		Keyboard.addListener('keyboardWillShow', keyboardShowing);
		Keyboard.addListener('keyboardWillHide', keyboardHiding);
	}

	// Listen for keyboard hide requests
	ChalkySticks.Core.Event.Bus.on('keyboard:hide.request', () => Keyboard.hide());

	// Configure keyboard behavior
	await Keyboard.setAccessoryBarVisible({ isVisible: false });

	hasInitialized = true;
}
